import { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { getProductQuery } from 'lib/core/services/magento/queries/productQuery'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { MagentoProductInterface } from 'lib/types'

export interface ProductsQueryObject {
  products: {
    __args: {
      filter: Record<string, Record<string, string>>
      [key: string]: any
    }
    [key: string]: any
  }
}

export const productsQueryObject: ProductsQueryObject = {
  products: {
    __args: {
      filter: {}
    }
  }
}

interface ProductsQueryInput {
  sku?: string
  skus?: string[]
  urlKey?: string
  base?: boolean
  details?: boolean
  links?: boolean
  amount?: number
}

export type GetProductsQuery =
  (input: ProductsQueryInput) =>
  Promise<AxiosResponse<{ data: { products: { items: MagentoProductInterface[] } } }>>

export const createProductsQuery = ({ getQueries }: ServiceDependencies): GetProductsQuery => async ({
  sku,
  skus,
  urlKey,
  base,
  details,
  links,
  amount
}) => {
  const queries = getQueries()
  const query = {
    ...queries.productsQuery,
    products: {
      ...queries.productsQuery.products,
      ...getProductQuery('items', {
        withBase: base,
        withCustomAttributes: base,
        withReviewSummary: base,
        withOnConfigurable: Boolean(base) || details,
        withRelated: links,
        withUpsell: links,
        withProductLinks: details,
        withMediaGallery: details,
        withBreadcrumb: details,
        withOnGiftCard: details && !process.env.REACT_APP_MAGENTO_CE,
        withOnCustomizable: details,
        withConfigurableVariants: details,
        withOnGroupedProduct: details,
        withStock: details
      }, true)
    }
  }

  if (amount) {
    query.products.__args.pageSize = amount
  }

  if (sku) {
    query.products.__args.filter.sku = {
      eq: encodeURIComponent(sku)
    }
  }

  if (skus) {
    const encodedSkus = skus.map(sku => {
      return encodeURIComponent(sku)
    })

    query.products.__args.filter.sku = {
      in: encodedSkus
    }
  }

  if (urlKey) {
    query.products.__args.filter.url_key = {
      eq: urlKey
    }
  }

  return axiosClient(jsonToGraphQLQuery(query), true)
}
